// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.flipped-content {
  transform: rotateY(180deg);
  transition: transform 0.3s;
}
.flip-front,
.flip-back {
  backface-visibility: hidden;
}
.flip-back {
  transform: rotateY(180deg);
}
.language-selector {
  --vs-search-input-bg: transparent;
  --vs-border-width: 0;
  --vs-controls-size: 0.7;
  --vs-font-size: 12px;
  --vs-dropdown-option-padding: 3px 12px;
  font-size: 12px;
}
.language-selector.vs--single.vs--open .vs__selected {
  position: relative;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
